var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_1808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 17.7011C19.7036 14.9081 19.6312 10.4523 16.8382 7.74868C14.0453 5.04508 9.58945 5.11751 6.88585 7.91045C4.18224 10.7034 4.25467 15.1592 7.04761 17.8628C9.84056 20.5664 14.2964 20.494 17 17.7011Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9512 9.99958L12.0488 15.9996",
    stroke: "white",
    strokeWidth: 1.43203,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13.0483L15 12.9508",
    stroke: "white",
    strokeWidth: 1.43203,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_1808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.892,
    height: 16.892,
    fill: "white",
    transform: "translate(0 12.9998) rotate(-45.9312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWhite);
export default __webpack_public_path__ + "static/media/add-white.a24e105a62217a922723d724495f3bbf.svg";
export { ForwardRef as ReactComponent };